import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72d52fc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_InitialMenu = _resolveComponent("InitialMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Title),
      _createVNode(_component_InitialMenu, {
        onClickNew: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-new', $event))),
        onClickMng: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-mng', $event))),
        onClickCloud: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click-cloud', $event))),
        onClickContrib: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click-contrib', $event))),
        onClickData: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click-data', $event)))
      })
    ])
  ]))
}